module.exports = __webpack_public_path__ + "static/media/Illus-FoodOnItsWay@2x.4f27233a.png";